module.exports = __webpack_public_path__ + "static/approach@3x-0bef522988c4a21a41c7d4cc12253bbe.jpg";